<div class="video-embed">
  <div class="video-embed__wrapper">
    @if (!isPlaying()) {
      <div
        class="video-embed__placeholder"
        [style.background-image]="thumbnailUrl() ? 'url(' + thumbnailUrl() + ')' : null"
        (click)="play()"
        (keydown.enter)="play()"
        (keydown.space)="play()"
        role="button"
        tabindex="0"
        aria-label="Reproducir vídeo"
      >
        <div class="video-embed__play-btn">
          <app-icon [icon]="playIcon" [size]="32" color="#FFFFFF" />
        </div>
      </div>
    } @else {
      <iframe
        [src]="safeVideoUrl()"
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        class="video-embed__iframe"
      ></iframe>
    }
  </div>
  @if (caption()) {
    <p class="video-embed__caption">{{ caption() }}</p>
  }
</div>
